// extracted by mini-css-extract-plugin
export var langSwitch = "langSwitch-module--langSwitch--be2f6";